import { BUSCAR_ULTIMOS_HISTORICOS_PRECO, LIMPAR_ULTIMOS_HISTORICOS_PRECO } from '../../actions/types'

const initialState = undefined

export default function reducerUltimosHistoricosPreco (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ULTIMOS_HISTORICOS_PRECO: {
      const historicos = action.payload.data;
      if (historicos) {
        return  historicos;
      }
      return []
    }

    case LIMPAR_ULTIMOS_HISTORICOS_PRECO:
        return [];
    
    default: {
      return state
    }
  }
}
